<template>
  <v-col
    v-bind="{ ...containerProps, ...containerOptions }"
    class="helmi-combo-box"
  >
    <helmi-subheader
      v-if="$attrs.label"
      :colors="labelColors || colors"
      :icon="$attrs.icon"
      :label="$attrs.label"
      class="pa-0 mb-1"
    />
    <v-combobox
      :id="$attrs.id"
      v-model="modelValue"
      :color="colors.base"
      :hide-no-data="!query"
      :items="items"
      :search-input.sync="query"
      :label="`Lisää ${$attrs.label.toLowerCase()}`"
      dense
      hide-details
      hide-selected
      multiple
      small-chips
      solo
    >
      <template #no-data>
        <v-list-item @click="addItem(query)">
          <span class="text-caption mr-2">
            Lisää
            <v-chip
              :color="colors.base"
              small
              v-text="query"
            />
            <span v-if="$vuetify.breakpoint.mdAndUp"> painamalla <kbd>Enter</kbd></span>
          </span>
        </v-list-item>
      </template>
      <template #selection="{ attrs, item, parent, selected }">
        <v-chip
          v-bind="attrs"
          :class="colors.text"
          :color="colors.base"
          :input-value="selected"
          small
        >
          <span
            class="pr-2"
          >
            {{ item }}
          </span>
          <v-icon
            :color="colors.base"
            small
            @click="removeItem(item)"
          >
            cancel
          </v-icon>
        </v-chip>
      </template>
    </v-combobox>
  </v-col>
</template>

<script>
import { EventBus } from '@/utils';

const getDefaultState = () => ({
  items: [],
  modelValue: [],
  query: null,
});

export default {
  name: 'HelmiComboBox',

  components: {
    'helmi-subheader': () => import('@/components/formElements/Subheader'),
  },

  inheritAttrs: false,

  props: {
    chapter: {
      type: String,
      default: '',
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    containerProps: {
      type: Object,
      default: () => ({}),
    },

    containerOptions: {
      type: Object,
      default: () => ({}),
    },

    labelColors: {
      type: Object,
      default: () => null,
    },

    propertyValue: {
      type: Array,
      default: () => [],
    },
  },

  data: getDefaultState,

  computed: {
    label() {
      return this.$attrs.chapter ? `${this.chapter} ${this.$attrs.label}` : this.$attrs.label;
    },
  },

  watch: {
    modelValue(newVal) {
      this.$emit('input', newVal);
      this.$emit('evaluate', newVal, this.$attrs.id);
    },
  },

  mounted() {
    this.handleValues();
    EventBus.$on('FORM_RESET', this.resetValue);
  },

  methods: {
    addItem(item) {
      if (!item) return;

      this.modelValue.push(item);
      this.query = '';
    },

    handleValues() {
      if (!this.$attrs.value || Array.isArray(this.$attrs.value)) return;

      this.modelValue = this.$attrs.value.split(',');
    },

    removeItem(item) {
      this.modelValue = this.modelValue.filter(i => i !== item);
    },

    resetValue() {
      Object.assign(this.$data, getDefaultState());
    },
  },
};
</script>

<style lang="scss">
.helmi-combo-box {
  .v-select--chips {
    color: inherit !important;

    .v-chip {
      background: transparent !important;
      // color: inherit !important;

      &::before {
        opacity: 0.12;
      }

      .v-icon {
        // color: inherit !important;
      }
    }
  }
}
</style>
